





































































import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { DateHelper } from "../core/helpers/dateHelper";

@Component({
  components: {},
})
export default class MySurveysPage extends Vue {
  items: any[] = [];
  errorMsg: string = "";

  async mounted() {
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    await this.loadData(cid);
  }

  async loadData(customerId: number) {
    let url = `${Settings.HostName}/api/publiccustomersurveys/customer-surveys/${customerId}`;
    let data = await new CrudService().httpGet(url);
    if (data == null) {
      this.errorMsg = this.$t("Crash").toString();
      console.error("Crash getting my surveys");
      return;
    }

    this.items = data;
  }

  isOpenable(item: any): boolean {
    return item.answeredDate !== null || item.token !== null;
  }

  statusText(item: any): string {
    if (item.answeredDate !== null) {
      return DateHelper.toCultureString(item.answeredDate);
    }
    if (item.expired === true) {
      return this.$t("Expired").toString();
    }
    return this.$t("Pending").toString();
  }

  open(item: any) {
    if (item.answeredDate !== null) {
      this.$router.push(`/customer-surveys/${item.id}`);
      return;
    }
    if (item.token !== null) {
      this.$router.push(`/survey/${item.token}`);
    }
  }
}
